import { Box, Typography, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import useOrganization from "../../hooks/useOrganization";
import { SAMLDataRequest } from "../../types/Organization.type";
import OrganizationBreadcrumbs from "../OrganizationBreadcrumbs";
import SAMLSettings from "../OrganizationDetails/SAMLSettings";

type Props = {
    id: string;
};

const OrganizationSamlSettings: React.FC<Props> = ({ id }) => {
    const theme = useTheme();
    const { organization, isLoading } = useOrganization({ id });
    const samlDefaultValues = useMemo<SAMLDataRequest>(
        () => ({
            enableSamlSso:
                !!organization?.saml2EntityId ||
                organization?.samlProviders?.some(
                    (provider) => provider.isEnabled,
                ),
            providers: organization?.samlProviders,
            authenticxDomain: organization?.saml2AuthenticxDomain,
            bindingType: organization?.saml2BindingType,
            certificateInPemFormat:
                organization?.saml2CertificateInPemFormat,
            entityId: organization?.saml2EntityId,
            loginButtonText: organization?.saml2LoginButtonText,
            samlResponseEmailPropertyName:
                organization?.saml2ResponseEmailPropertyName,
            samlResponseFirstNamePropertyName:
                organization?.saml2ResponseFirstNamePropertyName,
            samlResponseLastNamePropertyName:
                organization?.saml2ResponseLastNamePropertyName,
            singleSignOnServiceUrl:
                organization?.saml2SingleSignOnServiceUrl,
            singleSignOutServiceUrl:
                organization?.saml2SingleSignOutServiceUrl,
        }),
        [organization],
    );

    return (
        <Box
            sx={{
                padding: 4,
                maxWidth: `calc(100% - ${theme.spacing(4)})`,
                width: "1200px",
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >
            <OrganizationBreadcrumbs pageTitle="SAML SSO" />
            <Typography
                sx={{
                    fontSize: "24px",
                    fontWeight: 600,
                    color: theme.palette.gray[700],
                    mt: 2,
                }}
            >
                SAML SSO
            </Typography>
            <SAMLSettings
                defaultValues={samlDefaultValues}
                isLoading={isLoading}
                organizationId={id}
            />
        </Box>
    );
};

export default OrganizationSamlSettings;
